// react
import styled from 'styled-components';

// components
import { Button, Container, Icon, Logo, Title } from '@/components/atoms';

// assets
// @transform-path ../../../../../../src/assets/onboarding/conciergeTeam.jpg
import conciergeTeam from '@/assets/onboarding/conciergeTeam.jpg';

import {
  GenericFlowProps,
  OnboardingActions,
  OnboardingActionType,
  toGenericOnboarding,
} from '@/components/pages/OnboardingFlow/OnboardingFlow';

export const OnboardingActivatedStart = toGenericOnboarding(
  ({
    config,
    currentIndex = 0,
    handleClick,
  }: GenericFlowProps<OnboardingActivatedStartConfigItem>) => {
    return (
      <StyledContainer size='sm'>
        <Wrapper>
          <Title isCenter>{config[currentIndex]?.title}</Title>
          <ContentContainer>
            <Body>
              <ImageWrapper>
                <Icon fontSize={32} icon='hand-holding-heart' />
              </ImageWrapper>
              <BodyWrapper>
                <BodyTextWrapper>
                  {config[currentIndex]?.text.map((text) => (
                    <Text key={text}>{text}</Text>
                  ))}
                </BodyTextWrapper>
              </BodyWrapper>
            </Body>
            <Actions>
              <Button
                size='lg'
                ariaLabel={config[currentIndex]?.ctaButtonLabel}
                onPress={() => handleClick?.(OnboardingActionType.Next)}
                isFullWidth
              >
                {config[currentIndex]?.ctaButtonLabel}
              </Button>
              {config[currentIndex]?.onSkip && (
                <Button
                  size='lg'
                  ariaLabel='Skip For Now'
                  variant='link'
                  onPress={config[currentIndex]?.onSkip}
                >
                  Skip For Now
                </Button>
              )}
            </Actions>
          </ContentContainer>
        </Wrapper>
      </StyledContainer>
    );
  },
);

const StyledContainer = styled(Container)`
  background: ${(props) => props.theme.color.cards.yellow.secondary};
  height: unset;
  flex: 1;
`;

const BodyTextWrapper = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing[16]};
`;

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[32]};
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.spacing[24]};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: ${(props) => props.theme.spacing[24]}
    ${(props) => props.theme.spacing[12]};
  padding-bottom: ${(props) => props.theme.spacing[48]};
  gap: ${(props) => props.theme.spacing[20]};
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  min-width: 120px;
  min-height: 120px;
  max-width: 120px;
  max-height: 120px;
  background: ${(props) => props.theme.color.cards.green.tertiary};
  border-radius: 99999px;
  color: ${(props) => props.theme.color.cards.yellow.secondary};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[24]};
  flex: 1;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  max-width: 100%;
`;

const Text = styled.div`
  font: ${(props) => props.theme.typography.body.md.regular};
  color: ${(props) => props.theme.color.neutral[100]};
  text-align: center;
  @media (min-width: 546px) {
    font: ${(props) => props.theme.typography.body.md.regular};
  }
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[16]};
  width: 100%;
`;

export interface OnboardingActivatedStartConfigItem extends OnboardingActions {
  id: string;
  title: string;
  text: Array<string>;
  ctaButtonLabel: string;
  onSkip?: () => void;
}

OnboardingActivatedStart.displayName = 'OnboardingActivatedStart';
export default toGenericOnboarding(OnboardingActivatedStart);
